export default "__VITE_ASSET__DkRkB9nx__"